import { render, staticRenderFns } from "./BriefManagement.vue?vue&type=template&id=07133081&scoped=true&"
import script from "./BriefManagement.vue?vue&type=script&lang=js&"
export * from "./BriefManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07133081",
  null
  
)

export default component.exports